import React, { useEffect, useState } from 'react'

import { useLocation } from 'react-router-dom';

import { fetchTabaTeurTochnitData } from '../../server/ServerFunc';
import Section from '../Section';
import AppHeaderGlobal from '../AppHeaderGlobal';
import AppFooter from '../AppFooter';

const TeurInfo = ({ isSeparate }) => {
   const [teurTaba, setTeurTaba] = useState("");
   const search = useLocation().search;

   useEffect(() => {
      const tikNumURL = new URLSearchParams(search).get("TikNum");
      getTeurTabaContent(tikNumURL);
    }, []);

   const getTeurTabaContent = async (tikTaba) => {
      const teurData = await fetchTabaTeurTochnitData(tikTaba);
      if(teurData && teurData.teur !== "") {
         setTeurTaba(teurData.teur);
      } else {
         setTeurTaba("");
      }
   }
  
  return (
    <>
      { isSeparate && <AppHeaderGlobal /> }
      {
        <div className="container my-3 my-lg-5">
          <Section icon={'clipboard-info'} title={'תיאור התוכנית'} id={'תיאור התוכנית'}>
            {
              teurTaba !== "" ?
                <div dangerouslySetInnerHTML={{ __html: teurTaba }} />
                :
                <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
            }
          </Section>
        </div>
      }
      { isSeparate && <AppFooter /> }
    </>
  )
}

export default TeurInfo